<script lang="ts">
  let { color = 'currentColor' } = $props()
</script>

<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.5 2.5H6.83331C6.28103 2.5 5.83331 2.94772 5.83331 3.5V16.5C5.83331 17.0523 6.28103 17.5 6.83331 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5V3.5C17.5 2.94772 17.0523 2.5 16.5 2.5Z"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M5.83331 3.75H3.08331C2.53103 3.75 2.08331 4.19772 2.08331 4.75V7.75C2.08331 8.30228 2.53103 8.75 3.08331 8.75H5.83331"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M5.41667 11.6667H4.75C4.19771 11.6667 3.75 12.1144 3.75 12.6667V15.25C3.75 15.8023 4.19772 16.25 4.75 16.25H5.83333"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
  <path
    d="M11.6666 3.33331V17.0833M5.83331 9.99998H17.0833"
    stroke={color}
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
